document.addEventListener('DOMContentLoaded', function() {
  var loadMoreButton = document.querySelector('.load-more_btn');
  var nextUrl = document.querySelector('#product-grid').getAttribute('data-next-url');
  var productGrid = document.querySelector('#product-grid');

  if (loadMoreButton) {
    loadMoreButton.addEventListener('click', function() {
      if (nextUrl) {
        loadMoreButton.style.display = 'none';
        document.querySelector('.load-more_spinner').style.display = 'block';
        
        fetch(nextUrl)
          .then(response => response.text())
          .then(data => {
            var parser = new DOMParser();
            var doc = parser.parseFromString(data, 'text/html');
            var newProducts = doc.querySelectorAll('#product-grid .grid__item');
            var newNextUrl = doc.querySelector('#product-grid').getAttribute('data-next-url');

            newProducts.forEach(product => {
              productGrid.appendChild(product);
            });

            if (newNextUrl) {
              nextUrl = newNextUrl;
              loadMoreButton.style.display = 'block';
            } else {
              loadMoreButton.style.display = 'none';
            }

            document.querySelector('.load-more_spinner').style.display = 'none';
          })
          .catch(error => {
            console.error('Error loading more products:', error);
            loadMoreButton.style.display = 'block';
            document.querySelector('.load-more_spinner').style.display = 'none';
          });
      }
    });
  }
});
